import {ApiException, PermissionDenied, RecordNotFound, ValidationError} from "@/domain/core/exception/exceptions"
import axiosRetry from "axios-retry"

export default class ApiClient {

    constructor(axios) {
        this.axios = axios
    }

    async get(url, params) {
        const result = await this.axios.get(url, {params: params}).catch(error => this.throw_exception(error))
        return result.data
    }

    async post(url, params, queryParams) {
        const result = await this.axios.post(url , params, {params: queryParams}).catch(error => this.throw_exception(error))
        return result.data
    }

    async patch(url, params) {
        const result = await this.axios.patch(url, params).catch(error => this.throw_exception(error))
        return result.data
    }

    async delete(url, queryParams) {
        const result = await this.axios.delete(url, {params: queryParams}).catch(error => this.throw_exception(error))
        return result.data
    }

    async put(url, params) {
        const result = await this.axios.put(url, params).catch(error => this.throw_exception(error))
        return result.data
    }


    buildQueryString(queryParams) {
        if (!queryParams) return '';
        const query = Object.keys(queryParams)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(queryParams[k]))
            .join('&');
        return '?' + query;
    }

    upload(url, form, onProgress, signal) {
        return this.axios.post(url, form, {
            headers: {'Content-Type': 'multipart/form-data'},
            'axios-retry': {
                // POST is NOT idempotent HTTP method, but this API is safe, so we override the axios-retry
                retries: 4,
                retryDelay: (retryNumber) => Math.pow(2, retryNumber) * 1500,
                retryCondition: axiosRetry.isRetryableError,
            },
            signal: signal,
            onUploadProgress: (progressEvent) => {
                onProgress({
                    loaded: progressEvent.loaded,
                    total: progressEvent.total
                })
            }
        }).catch(error => this.throw_exception(error))
    }

    throw_exception(error) {
        if (error.response) {
            if (error.response.status === 404)
                throw new RecordNotFound(error.response.config.url, error.response.status, error.response.data)
            if (error.response.status === 403)
                throw new PermissionDenied(error.response.config.url, error.response.status, error.response.data)
            if (error.response.status === 400)
                throw new ValidationError(error.response.config.url, error.response.status, error.response.data)
        }
        throw new ApiException(error.response.config.url, error.response.status, error.response.data)
    }
}
